/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartMedicineHospitalDetailAliases {
  BREADCRUMB_MEDICINE = 'breadcrumb-medicine',
  CONTEXTUAL_BAR_MEDICINE_HOSPITAL_DETAIL = 'contextual-bar-medicine-hospital-detail',
  FIELD_CONTINUOUS_MEDICATION = 'field-continuous-medication',
  FIELD_DONT_KNOW_DOSE = 'field-dont-know-dose',
  FIELD_DOSE = 'field-dose',
  FIELD_END_DATE = 'field-end-date',
  FIELD_INTERVAL = 'field-interval',
  FIELD_MEDICINE = 'field-medicine',
  FIELD_NOTES = 'field-notes',
  FIELD_START_DATE = 'field-start-date',
  FIELD_UNIT_MEASUREMENT = 'field-unit-measurement',
  FORM_MEDICINE_HOSPITAL = 'form-medicine-hospital',
  INPUT_HOSPITAL_MEDICINES_FORMULARY_CONTINUOUS_MEDICATION_MY_CHART_MEDICINE_HOSPITAL_DETAIL = 'input-hospital-medicines-formulary-continuous-medication-my-chart-medicine-hospital-detail',
  INPUT_HOSPITAL_MEDICINES_FORMULARY_DONT_KNOW_DOSE_MY_CHART_MEDICINE_HOSPITAL_DETAIL = 'input-hospital-medicines-formulary-dont-know-dose-my-chart-medicine-hospital-detail',
  INPUT_HOSPITAL_MEDICINES_FORMULARY_DOSE_MY_CHART_MEDICINE_HOSPITAL_DETAIL = 'input-hospital-medicines-formulary-dose-my-chart-medicine-hospital-detail',
  INPUT_HOSPITAL_MEDICINES_FORMULARY_END_DATE_MY_CHART_MEDICINE_HOSPITAL_DETAIL = 'input-hospital-medicines-formulary-end-date-my-chart-medicine-hospital-detail',
  INPUT_HOSPITAL_MEDICINES_FORMULARY_INTERVAL_MY_CHART_MEDICINE_HOSPITAL_DETAIL = 'input-hospital-medicines-formulary-interval-my-chart-medicine-hospital-detail',
  INPUT_HOSPITAL_MEDICINES_FORMULARY_START_DATE_MY_CHART_MEDICINE_HOSPITAL_DETAIL = 'input-hospital-medicines-formulary-start-date-my-chart-medicine-hospital-detail',
  INPUT_HOSPITAL_MEDICINES_FORMULARY_UNIT_MEASUREMENT_MY_CHART_MEDICINE_HOSPITAL_DETAIL = 'input-hospital-medicines-formulary-unit-measurement-my-chart-medicine-hospital-detail',
  LAYOUT_MEDICINE_HOSPITAL_DETAIL = 'layout-medicine-hospital-detail',
  PANEL_MEDICINE_HOSPITAL = 'panel-medicine-hospital',
  TEXT_HOSPITAL_MEDICINES_FORMULARY_MEDICINE_MY_CHART_MEDICINE_HOSPITAL_DETAIL = 'text-hospital-medicines-formulary-medicine-my-chart-medicine-hospital-detail',
  TEXT_HOSPITAL_MEDICINES_FORMULARY_NOTES_MY_CHART_MEDICINE_HOSPITAL_DETAIL = 'text-hospital-medicines-formulary-notes-my-chart-medicine-hospital-detail',
}
export { MyChartMedicineHospitalDetailAliases };
